import React, { useState, useEffect, useMemo } from "react";
import Dashboard from "components/dashboard";
import { validationSchema, mutation, defaultValues, handleSubmit, NewGraphicsetForm, getQuery } from "./forms/new-form";
import { PageSection, PageHeaderBar } from "components/page";
import { useMutation } from "@apollo/react-hooks";
import DataGrid from "components/data-grid";
import { useQuery } from "components/graphql";
import { useCurrentCustomerContext } from "components/current-customer-context";
import ValidatedForm from "components/form";
import FormConfirm from "components/form/form-confirm";
import { getEntityWithoutTypename } from "pages/utils";
import { useAuthDataContext } from "components/auth";
import { useLoadingContext } from "components/loading-spinner-overlay";
import { mutation as assetMutation } from "pages/asset/forms/new-form";
import handleSubmitCompleteForm from "./forms/handle-submit";
import uniqueId from "lodash/uniqueId";

const GraphicsetNewPage = ({
  intl,
  history,
  match: {
    params: { id, customerId: customerIdCopy },
  },
}) => {
  const [createGraphicSet] = useMutation(mutation);
  const { currentCustomerId } = useCurrentCustomerContext();
  const query = useMemo(() => getQuery(id, customerIdCopy), [id, customerIdCopy]);
  const { data, loading, error } = useQuery(query);
  const [createAsset] = useMutation(assetMutation);

  const genericFileErrorMessage = intl.formatMessage({ id: "fileupload.error.generic.message" });
  const genericErrorMessage = intl.formatMessage({ id: "common.error" });
  const { token } = useAuthDataContext();
  const { setProgress, setLoading } = useLoadingContext();

  const [initialValues, setInitialValues] = useState(defaultValues(customerIdCopy || currentCustomerId));
  const graphicSetToCopy = data ? data.graphicset : null;

  const onSubmit = (values, setFieldError) =>
    handleSubmitCompleteForm({
      handleSubmit,
      createAsset,
      genericFileErrorMessage,
      genericErrorMessage,
      token,
      customerId: customerIdCopy || currentCustomerId,
      setProgress,
      mutation: createGraphicSet,
      history,
      setLoading,
    })(values, setFieldError);

  useEffect(
    () => {
      if (!loading && graphicSetToCopy) {
        const value = getEntityWithoutTypename(graphicSetToCopy);
        setInitialValues({
          ...value,
          id: undefined,
          layouts: value.layouts
            .sort((a, b) => a.order - b.order)
            .map(layout => ({
              ...layout,
              id: uniqueId(),
              asset: {},
              segments: layout.segments.map(segment => ({
                ...segment,
                id: uniqueId(),
              })),
            })),
          asset: undefined,
        });
      }
    },
    [graphicSetToCopy, loading],
  );

  return (
    <Dashboard>
      <PageHeaderBar title="app.page.graphicset.new" />
      <PageSection>
        <FormConfirm show={error} error label={intl.formatMessage({ id: "common.graphql.error" })} />
        {!error && (
          <ValidatedForm initialValues={initialValues} validationSchema={validationSchema(intl)} onSubmit={onSubmit}>
            {props => (
              <DataGrid>
                <NewGraphicsetForm {...props} />
              </DataGrid>
            )}
          </ValidatedForm>
        )}
      </PageSection>
    </Dashboard>
  );
};

export default GraphicsetNewPage;
